import { render, staticRenderFns } from "./AseanCpa.vue?vue&type=template&id=248c3628&scoped=true&"
import script from "./AseanCpa.vue?vue&type=script&lang=js&"
export * from "./AseanCpa.vue?vue&type=script&lang=js&"
import style0 from "./AseanCpa.vue?vue&type=style&index=0&id=248c3628&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c3628",
  null
  
)

export default component.exports